import React from "react";
import "./Summary.scss";

class Summary extends React.PureComponent {
  render() {
    return (
        <div className="Summary">
            <p className="Summary__title">Developer Summary</p>
            <p className="Summary__description">
                Detail-oriented and accomplished Salesforce Developer with{" "}
                <b>4 years</b> of experience in designing, developing, and
                implementing effective Salesforce solutions. As a certified
                professional with a strong background in Lightning Web
                Components, Salesforce Communities, and various Salesforce
                tools, I am seeking a Senior/Lead Developer role in a
                medium-sized company or a Developer role in a large
                organization, where I can gain valuable insights and learn from
                exceptional team members while contributing to the company's
                success.
            </p>
            <h2>Professional Experience</h2>
            <ul>
                <li>
                    Developed and maintained scalable and secure Salesforce
                    applications, including custom objects, workflows, triggers,
                    Lightning Web Components, and Visualforce pages.
                </li>
                <li>
                    Specialized in creating multilingual and RTL Salesforce
                    Communities with custom themes, ensuring an accessible and
                    user-friendly experience for global audiences.
                </li>
                <li>
                    Designed and implemented platform events for real-time
                    communication and data synchronization between Salesforce
                    and external systems.
                </li>
                <li>
                    Participated in the full software development lifecycle,
                    from requirement gathering, design, and coding to testing
                    and deployment.
                </li>
                <li>
                    Collaborated with customers to analyze business requirements
                    and translate them into effective technical solutions.
                </li>
                <li>
                    Successfully configured Conga, DocuSign, and B2B Commerce to
                    enhance business process efficiency.
                </li>
                <li>
                    Configured and automated Jira for efficient project
                    management and collaboration.
                </li>
                <li>
                    Communicated with customers to provide accurate project
                    estimations, control scope, and monitor progress, ensuring
                    timely delivery of solutions.
                </li>
                <li>
                    Provided ongoing support for existing Salesforce
                    applications, addressing user-reported issues in a timely
                    manner.
                </li>
            </ul>

            <p className="Summary_contacts">
                <h3>Artsem Balunda</h3>
                <h3>Wrocław, Poland</h3>
                <a href="mailto:artsem.balunda@gmail.com">
                    artsem.balunda@gmail.com{" "}
                </a>
                <br />
                <a href="https://www.linkedin.com/in/artsem-balunda-9536251a1/">
                    Linkedin
                </a>
            </p>
            <p className="Summary_me"></p>
        </div>
    );
  }
}

export default Summary;
